import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@repo/ui/components/Base/Dialog";
import { DocumentForm } from "./DocumentForm";
import { Tooltip } from "@repo/ui/components/Base/Tooltip";
import { DOCUMENT_MOTIF } from "@/lib/constants";
import { CreateTriggerButton } from "@repo/ui/components/Base/CreateTriggerButton";
import type { DocumentDto } from "@/repositories/documentRepo";

export const CreateDocumentDialog = ({
  tenantId,
  disabled,
  onAddToItem,
  open: outerOpen,
  setOpen: outerSetOpen,
  initialUpload,
  initialUrl,
  initialData,
  onComplete,
}: {
  tenantId: string;
  disabled?: boolean;
  onAddToItem?: (document: DocumentDto) => void;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  initialUpload?: File;
  initialUrl?: string;
  initialData?: Partial<DocumentDto>;
  onComplete?: (document: DocumentDto) => void;
}) => {
  const [innerOpen, innerSetOpen] = useState(false);

  const controlled = outerOpen != null;
  const open = outerOpen ?? innerOpen;
  const setOpen = outerSetOpen ?? innerSetOpen;

  const handleOpenChange = () => setOpen(!open);
  // const handleAddAnother = () => setOpen(true);
  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      {controlled ? (
        <DialogTrigger className="hidden" />
      ) : (
        <Tooltip
          label={
            disabled
              ? "Select a team to create a document"
              : "Create a Document"
          }
          tooltipTriggerProps={{ disabled: disabled }}
          asChild
        >
          <DialogTrigger asChild>
            <CreateTriggerButton disabled={disabled} />
          </DialogTrigger>
        </Tooltip>
      )}
      <DialogContent preventClickout preventEscape>
        <DialogHeader className={DOCUMENT_MOTIF}>
          <DialogTitle>Upload and Create a Document</DialogTitle>
        </DialogHeader>
        <DocumentForm
          tenantId={tenantId}
          partialDocumentFormData={{
            ...initialData,
          }}
          initialUpload={initialUpload}
          initialUrl={initialUrl}
          handleCancel={handleOpenChange}
          handleComplete={handleOpenChange}
          onSubmit={onComplete}
          // addAnother={handleAddAnother}
          addToItem={onAddToItem}
          withinDialog
          withSaveAndSignButton
        />
      </DialogContent>
    </Dialog>
  );
};
